import "./Cloud.css"

export function Cloud({ left, top, size = 150, delay = 0 }) {
    const publicUrl = process.env.PUBLIC_URL || "";
    return (
        <div
            className="cloud"
            style={{
                left,
                top,
                width: size,
                height: size * 0.6,
                animationDelay: `${delay}s`,
                backgroundImage: `url('${publicUrl}/assets/cloud.svg')`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "contain",
            }}
        />
    );
}
